import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { useTranslation } from '@hooks';
import DomainDetails from './DomainDetails';
import DeleteDomainDialog from './DeleteDomainDialog';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        maxWidth: 520,
        width: 'calc(100% - 32px)',
    },
    '& .modal-base-content': {
        padding: '0 24px',
    },
});

const EditDomainModal = ({ open, onClose, domain, onDomainUpdated, onDomainDeleted }) => {
    const { t } = useTranslation();
    const [deleteOpen, setDeleteOpen] = useState(false);

    if (!domain) return null;

    return (
        <>
            <Modal
                isOpen={open}
                aboveModal
                handleClose={onClose}
                title={t('MicrositesPage.editDomain', { hostname: domain.hostname })}
                onPrimaryAction={onClose}
                primaryActionText={t('buttons.done')}
                onAdditionalAction={() => setDeleteOpen(true)}
                additionalTextButton={t('buttons.delete')}
                additionalButtonType="danger"
            >
                <DomainDetails domain={domain} onDomainUpdated={onDomainUpdated} />
            </Modal>
            <DeleteDomainDialog
                open={deleteOpen}
                onClose={() => setDeleteOpen(false)}
                domain={domain}
                onDeleted={id => {
                    setDeleteOpen(false);
                    onDomainDeleted(id);
                }}
            />
        </>
    );
};

export default EditDomainModal;
